import { formatEuro } from "@/lib/api";

export const formatDateFr = (iso) => {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
};

export const OldPrice = ({ svc, online = false, className = "" }) => {
  if (!svc.promo_live) return null;
  const before = online ? svc.price_online_before : svc.price_before;
  if (before === undefined || before === null) return null;
  return (
    <s
      className={`mr-1.5 text-xs font-normal text-muted-foreground ${className}`}
      data-testid={`old-price-${svc.slug}`}
    >
      {formatEuro(before)}
    </s>
  );
};

export const PromoBadge = ({ svc, className = "" }) => {
  if (!svc.promo_live) return null;
  return (
    <span
      className={`inline-flex items-center rounded-full bg-primary px-2 py-0.5 text-[10px] font-semibold text-primary-foreground ${className}`}
      data-testid={`promo-badge-${svc.slug}`}
    >
      -{Math.round(svc.promo_percent)}%
      {svc.promo_until ? ` jusqu'au ${formatDateFr(svc.promo_until)}` : ""}
    </span>
  );
};
